import { render } from "./generalCommont.vue?vue&type=template&id=19f0474a&scoped=true"
import script from "./generalCommont.vue?vue&type=script&lang=js"
export * from "./generalCommont.vue?vue&type=script&lang=js"

import "./generalCommont.vue?vue&type=style&index=0&id=19f0474a&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f0474a"]])

export default __exports__